// cn() — canonical class-name combinator used by every component in the
// LiveVane SPA. Backed by `clsx` for conditional truthy/falsey resolution
// and `tailwind-merge` to de-duplicate conflicting Tailwind utilities
// (e.g. `px-2` + `px-4` collapses to `px-4`).
//
// This matches the shadcn convention so the upcoming Card / Button / Input
// primitives in task 2 can rely on it without further changes.
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export type { ClassValue }

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(...inputs))
}

/** Convert a browser datetime-local value to YYYY-MM-DD HH:MM:SS. */
export function toApiDateTime(localVal: string): string {
  if (localVal === '') return ''
  const parts = localVal.replace('T', ' ')
  return parts.length === 16 ? `${parts}:00` : parts
}
